module.exports = __webpack_public_path__ + "img/9.e66b2111.jpg";